import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import {
  Alert,
  Card,
  Button,
  CardTitle,
  Form,
  FormGroup,
  CardFooter,
  FormFeedback,
  Label,
  Input,
  Col,
  Collapse
} from "reactstrap";
import axios from "axios";
import "../App.css";
import { useNavigation } from "react-navi";
import { useSelector, useDispatch } from "react-redux";
import { useFormInput } from "../hooks/generalHooks";
import { updateAttribute } from "../redux/actions/generalActions";

export function SignIn(props) {
  const [signInError, setSignInError] = useState(false);
  const email = useFormInput("");
  const password = useFormInput("");
  const topRef = useRef();
  const navigation = useNavigation();
  const isAuthenticated = useSelector(
    state => state.generalReducer.isAuthenticated
  );

  const dispatch = useDispatch();

  function handleReset() {
    email.setValue("");
    password.setValue("");
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const data = new FormData();

    // Adding data to form
    data.append("email", email.value);
    data.append("password", password.value);

    try {
      await axios
        .post(`${process.env.REACT_APP_API_URL}login`, data)
        .then(response => {
          localStorage.setItem("jwtToken", response.data.token);
          dispatch(
            updateAttribute({
              isAuthenticated: true
            })
          );
          axios.defaults.headers.common.Authorization = `Bearer ${
            response.data.token
          }`;
          navigation.navigate("/");
        });
    } catch (err) {
      setSignInError(true);
    }
  }

  const signInErrorAlert = signInError ? (
    <Alert color="danger">Invalid email/password combination</Alert>
  ) : null;

  return (
    <div className="container-fluid justify-content-center d-flex centered-card ">
      <Col
        style={{ maxWidth: "750px" }}
        className="justify-content-center d-flex"
      >
        <Card
          outline
          color="dark"
          className="card-chart justify-content-center align-self-center col-md-12 card-black"
        >
          <span ref={topRef} />

          <CardTitle className="mt-3 justify-content-center d-flex">
            {" "}
            <h2>
              <b>Please sign in to continue.</b>
            </h2>{" "}
          </CardTitle>
          <hr className="hr-black" />
          {signInErrorAlert}
          <Form className="form" onSubmit={handleSubmit}>
            <fieldset>
              <FormGroup row>
                <Label for="email" sm={2}>
                  Email{" "}
                </Label>
                <Col sm={10}>
                  <Input
                    required
                    type="email"
                    name="email"
                    id="email"
                    {...email.formProps}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label for="email" sm={2}>
                  Password
                </Label>
                <Col sm={10}>
                  <Input
                    required
                    type="password"
                    name="password"
                    id="password"
                    {...password.formProps}
                  />
                </Col>
              </FormGroup>
            </fieldset>

            <FormGroup
              check
              row
              className=" mb-3 d-flex justify-content-center"
            >
              <Col>
                <Button
                  outline
                  className=" btn-block btn-black btn btn-outline-dark"
                  type="submit"
                  disabled={!email.value || !password.value}
                >
                  Submit
                </Button>
              </Col>
              <Col>
                <Button
                  outline
                  className="btn-red btn-block btn btn-outline-danger"
                  type="reset"
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Card>
      </Col>
    </div>
  );
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/views/signin.jsx